/**
 * Case-insensitive match for the Daniyal employee account (sub-jobs, subtask logs).
 */
export function isDaniyalUserId(
  userId: string | undefined | null,
  daniyalKey: string,
): boolean {
  return (
    String(userId ?? "")
      .trim()
      .toLowerCase() === String(daniyalKey).trim().toLowerCase()
  );
}
